export default {
  full_menu: 'Menü',
  free: 'GRATIS',
};
